import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { axios_instance } from "../api/axios_instance";
import { toast } from "react-toastify";

const ProtectedRoute = ({ children }) => {
  toast.dismiss();
  const navigate = useNavigate();

  axios_instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error?.response && error?.response?.status === 401) {
        alert(error?.response?.data?.message, {
          theme: "colored",
        });

        localStorage.clear();
        navigate("/");

        window.alert = () => {};
      }
      return Promise.reject(error);
    }
  );

  if (!localStorage.token) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
